import { useState } from 'react';
import { calcCushion, getStatus } from './storage';

export default function TrailStopModal({ position, onSave, onClose, liveStatus }) {
  const [newStop, setNewStop] = useState('');
  const [error, setError]     = useState('');

  const current = Number(position.stopPrice);

  function handleSubmit(e) {
    e.preventDefault();
    const val = Number(newStop);

    if (val <= current) {
      setError('Stop-loss can only move upward');
      return;
    }
    setError('');
    onSave(position.id, val);
  }

  function handleChange(e) {
    setNewStop(e.target.value);
    if (error) setError('');
  }

  const previewCushion = newStop
    ? calcCushion(position.currentPrice, Number(newStop))
    : null;
  const previewStatus  = previewCushion !== null ? getStatus(previewCushion) : null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card modal-card--narrow" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Trail Stop — {position.name}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="trail-info">
          <div className="trail-stat">
            <span className="trail-stat-label">Current Price</span>
            <div className="trail-price-row">
              <span className="trail-stat-value">${Number(position.currentPrice).toFixed(2)}</span>
              {liveStatus && (
                <span className={`live-badge live-badge--${liveStatus}`}>
                  <span className="live-dot" />
                  {liveStatus === 'live'    ? 'Live'
                    : liveStatus === 'offline' ? 'Offline'
                    : 'Manual'}
                </span>
              )}
            </div>
          </div>
          <div className="trail-stat">
            <span className="trail-stat-label">Current Stop</span>
            <span className="trail-stat-value">${current.toFixed(2)}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <label className="form-label">
            New Stop-Loss Price ($)
            <input
              type="number"
              className={`form-input${error ? ' form-input--error' : ''}`}
              min="0"
              step="any"
              value={newStop}
              onChange={handleChange}
              placeholder={`> ${current.toFixed(2)}`}
              required
              autoFocus
            />
          </label>

          {error && (
            <p className="form-error">{error}</p>
          )}

          {previewCushion !== null && !error && (
            <div className="trail-preview">
              <span>New cushion: </span>
              <span className={`cushion-${previewStatus?.toLowerCase()}`}>
                {previewCushion.toFixed(1)}%
              </span>
              <span className={`status-pill status-${previewStatus?.toLowerCase()} status-pill--sm`}>
                {previewStatus}
              </span>
            </div>
          )}

          {position.stopHistory?.length > 0 && (
            <div className="stop-history">
              <p className="stop-history-title">Stop History</p>
              <div className="stop-history-list">
                {[...position.stopHistory].reverse().slice(0, 5).map((h, i) => (
                  <div key={i} className="stop-history-row">
                    <span className="history-date">
                      {new Date(h.date).toLocaleDateString(undefined, {
                        month: 'short', day: 'numeric', year: '2-digit',
                      })}
                    </span>
                    <span className="history-arrow">
                      ${Number(h.oldStop).toFixed(2)} → ${Number(h.newStop).toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">Raise Stop</button>
          </div>
        </form>
      </div>
    </div>
  );
}
